export const GAU_PACKS_DOCS_URL =
  "https://docs.superblocks.com/building-with-clark/ai-credits";

export function GauPacksLink() {
  return (
    <a
      className="text-[#6c7689] underline"
      href={GAU_PACKS_DOCS_URL}
      rel="noreferrer"
      target="_blank"
    >
      GAU Packs
    </a>
  );
}
